module.exports = __webpack_public_path__ + "images/avatars/female/10.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/10.png
// module id = 4jE+
// module chunks = 118